const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDropdownClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "dropdown button"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 167",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31",
    d: "M5.5 104.141a.729.729 0 0 1-.545-.252l-4.73-5.28a.932.932 0 0 1 0-1.216.715.715 0 0 1 1.089 0l4.186 4.672 4.185-4.672a.715.715 0 0 1 1.089 0 .932.932 0 0 1 0 1.216l-4.73 5.28a.729.729 0 0 1-.544.252z",
    transform: "translate(6.999 -88.141)",
    style: {
      fill: "#0222ba"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdownClosed);
export default __webpack_public_path__ + "static/media/icon-dropdown-closed.a36a4ec54bcea61d61d957a1a0c11a0f.svg";
export { ForwardRef as ReactComponent };